<ui-confirmation-dialog
    header="change-requests.actionTitle.cancelRequest"
    primaryButtonLabel="cancel"
    primaryButtonType="danger"
    secondaryButtonLabel="close"
    #confirmCancelRequest
>
    <div class="margin-bottom-2">
        <p>{{ 'change-requests.canceledRequestInstruction' | translate }}</p>
    </div>
</ui-confirmation-dialog>

<ui-confirmation-dialog
    #confirmApprovalAction
    header="{{ confirmApprovalActionHeader }}"
    primaryButtonLabel="{{ actionToConfirm }}"
    primaryButtonType="primary"
    secondaryButtonLabel="close"
>
    <p style="white-space: pre-line">{{ approvalActionMessage | translate }}</p>
    <mat-form-field *ngIf="canApprovalActionHaveClosingComment" class="columns-12">
        <mat-label
            [innerHTML]="
                'change-requests.actionPanel.comment' | translate: { actionToConfirm: (actionToConfirm | translate) }
            "
        ></mat-label>
        <textarea rows="6" name="closingComment" [(ngModel)]="approvalActionClosingComment" matInput> </textarea>
    </mat-form-field>
</ui-confirmation-dialog>

<div class="page-container" [class.loading]="isLoading">
    <app-header
        title="{{
            ChangeRequestTemplateDisplayOptions[changeRequest.template.name] || changeRequest.template.name | translate
        }} - {{ changeRequest.subject.fullName }}"
        [back]="true"
        backRoute="/change-requests/requests"
    >
        <div *ngIf="canBeCancelled" class="buttons">
            <ui-button type="outline" (click)="onCancel()"
                >{{ 'change-requests.cancelRequest' | translate }}
            </ui-button>
        </div>
    </app-header>

    <div class="profile-layout reverse">
        <div class="profile-layout-content">
            <ui-card>
                <div
                    class="template-description"
                    *ngIf="changeRequest.template.description && changeRequest.isPending()"
                >
                    <h2>{{ 'change-requests.description' | translate }}</h2>
                    <p class="margin-bottom-0">{{ changeRequest.template.description }}</p>
                    <hr class="margin-top-3 margin-bottom-3" />
                </div>

                <h2>{{ 'change-requests.requestDetails' | translate }}</h2>

                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th class="column-heading" scope="col">
                                {{ 'change-requests.displayValue' | translate: { status: status } }}
                            </th>
                            <th aria-hidden="true" role="presentation"></th>
                            <th class="column-heading" scope="col">{{ 'change-requests.updatedValue' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (fieldValue of changeRequest.fieldValues; track fieldValue.id) {
                            <tr>
                                <th scope="row" class="row-heading">
                                    {{ fieldValue.field.name | appTranslateOptions: changeRequestTemplateFields }}
                                </th>
                                <td>
                                    <field-value-display-component
                                        *ngIf="!isLoading"
                                        [value]="fieldValue.oldValue"
                                        [fieldKey]="fieldValue.field.key"
                                    ></field-value-display-component>
                                </td>
                                <td aria-hidden="true" role="presentation">
                                    <mat-icon svgIcon="arrowRight" />
                                </td>
                                <td>
                                    <div
                                        *ngIf="!isLoading && fieldValue.isUpdated && fieldValue.newValue"
                                        class="field-value-changed"
                                    >
                                        <field-value-display-component
                                            [value]="fieldValue.newValue"
                                            [fieldKey]="fieldValue.field.key"
                                        ></field-value-display-component>
                                    </div>
                                    <span *ngIf="!fieldValue.isUpdated" class="field-value-not-changed">{{
                                        'change-requests.noChange' | translate
                                    }}</span>
                                    <span
                                        *ngIf="fieldValue.isUpdated && !fieldValue.newValue"
                                        class="field-value-not-changed"
                                        >{{ 'change-requests.removed' | translate }}
                                    </span>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
                <div class="vertical-label margin-top-3">
                    <label>{{ 'change-requests.effectiveDate' | translate }}</label>
                    {{ changeRequest.effectiveAt | i18nDate: 'long' }}
                </div>
            </ui-card>
        </div>
        <div class="profile-layout-sidebar">
            <change-request-approval-instance-flow
                #approvalFlow
                [changeRequest]="changeRequest"
                [isAdmin]="auth.isAdmin()"
                (approvalActioned)="confirmAction($event)"
            ></change-request-approval-instance-flow>
        </div>
    </div>
</div>
